export default "__VITE_ASSET__BKj$_D1s__"